import { useEffect } from 'react';
import SearchOffIcon from '@mui/icons-material/SearchOff';

export default function NoResultsFound({ searchTerm = "" }) {
  return (
    <div className="flex flex-col items-center justify-center py-12 w-full">
      <div className="flex items-center justify-center w-16 h-16 mb-4 bg-gray-100 rounded-full">
        <SearchOffIcon className="text-gray-400" style={{ fontSize: 32 }} />
      </div>
      
      <h3 className="mb-2 text-lg font-medium text-gray-900">
        No results found
      </h3>
      
      <p className="text-center text-gray-500 max-w-md">
        {searchTerm ? 
          `We couldn't find any matches for "${searchTerm}". Try adjusting your search criteria.` : 
          "No API keys available. Create a new key to get started."}
      </p>
      
      <div className="mt-6">
        <svg 
          width="200" 
          height="120" 
          viewBox="0 0 200 120" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          className="text-gray-200"
        >
          {/* Stylized empty result illustration */}
          <rect x="40" y="20" width="120" height="16" rx="2" fill="currentColor" opacity="0.3" />
          <rect x="40" y="44" width="120" height="16" rx="2" fill="currentColor" opacity="0.2" />
          <rect x="40" y="68" width="120" height="16" rx="2" fill="currentColor" opacity="0.1" />
          <circle cx="140" cy="40" r="32" stroke="currentColor" strokeWidth="2" strokeDasharray="4 4" />
          <path d="M155 40L125 40" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" />
          <path d="M140 25L140 55" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </div>
    </div>
  );
}